import { useState } from 'react';
import { Box, Stack, TextField } from '@mui/material';
import Button from './Button';
import TagEditor from './TagEditor';

function EditableTagEditor({ label, values, onChange, options, disabled = false, placeholder = 'Add custom option' }) {
  const [custom, setCustom] = useState('');
  return (
    <Box>
      <TagEditor label={label} values={values} onChange={onChange} options={options} disabled={disabled} />
      <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
        <TextField
          size="small"
          disabled={disabled}
          value={custom}
          onChange={(event) => setCustom(event.target.value)}
          placeholder={placeholder}
        />
        <Button
          disabled={disabled}
          variant="secondary"
          onClick={() => {
            const value = custom.trim();
            if (!value) return;
            onChange(values.includes(value) ? values : [...values, value]);
            setCustom('');
          }}
        >
          Add
        </Button>
      </Stack>
    </Box>
  );
}

export default EditableTagEditor;
